import * as accountService from '/source/js/services/accountService';
import * as recommendedCartService from '/source/js/services/recommendedCartService';
import {
    loadSpinner,
    stopSpinner
} from '/source/_patterns/01-components/spinner/spinner';
const $window = $(window);
const ACTIVE = 'active';
let startTime;
let endTime;
let firstActive = false;
let animateNavCont = 'animate-navigation-container';
let animateNavPost = 'nav-animate-position';
let animateNavRow = 'animate-navigation-row';
let animateQuizButton = 'animate-quiz-button';
let animateShadow = 'animate-shadow';
let animateTypo = 'animate-typo';
let reverseAnimation = 'reverse';

// Foward Animations
function fowardAnimation(timestamp, duration) {
    let $navbarBP = $('.navbar-brand-partner');
    if($navbarBP.length > 0) return;

    let $headerNavbar = $('.isa-header__container-navbar');
    let $typography = $('.navbar-brand__image-typo, .consultant-profile');
    let $navigation = $('.navbar-row__navigation');
    let $quizButton = $('.navbar-nav__item-quiz');
    let $navRow = $('.navigation-row');
    let time = timestamp || new Date().getTime();
    let runtime = time - startTime;

    if(runtime < duration) {
        requestAnimationFrame(function(timestamp) { // eslint-disable-line
            fowardAnimation(timestamp, duration);
        });
    }

    $navRow.addClass(`${animateNavRow}`);
    $typography.addClass(`${animateTypo}`);
    $navigation.addClass(`${animateNavPost}`);
    $navigation.addClass(`${animateNavPost}`);
    $headerNavbar.addClass(`${animateShadow}`);
    $headerNavbar.addClass(`${animateNavCont}`);
    $quizButton.addClass(`${animateQuizButton}`);

    $navRow.removeClass(`${animateNavRow}-${reverseAnimation}`);
    $typography.removeClass(`${animateTypo}-${reverseAnimation}`);
    $navigation.removeClass(`${animateNavPost}-${reverseAnimation}`);
    $headerNavbar.removeClass(`${animateNavCont}-${reverseAnimation}`);
    $quizButton.removeClass(`${animateQuizButton}-${reverseAnimation}`);
}

// Reverse Animations
function reverseAnimations(timestamp, duration) {
    let $navbarBP = $('.navbar-brand-partner');
    if($navbarBP.length > 0) return;

    let $headerNavbar = $('.isa-header__container-navbar');
    let $typography = $('.navbar-brand__image-typo, .consultant-profile');
    let $navigation = $('.navbar-row__navigation');
    let $quizButton = $('.navbar-nav__item-quiz');
    let $navRow = $('.navigation-row');
    let time = timestamp || new Date().getTime();
    let runtime = time - endTime;

    if(runtime < duration) {
        requestAnimationFrame(function(timestamp) { // eslint-disable-line
            reverseAnimations(timestamp, duration);
        });
    }

    $navRow.addClass(`${animateNavRow}-${reverseAnimation}`);
    $typography.addClass(`${animateTypo}-${reverseAnimation}`);
    $navigation.addClass(`${animateNavPost}-${reverseAnimation}`);
    $headerNavbar.addClass(`${animateNavCont}-${reverseAnimation}`);
    $quizButton.addClass(`${animateQuizButton}-${reverseAnimation}`);

    $navRow.removeClass(`${animateNavRow}`);
    $typography.removeClass(`${animateTypo}`);
    $navigation.removeClass(`${animateNavPost}`);
    $headerNavbar.removeClass(`${animateShadow}`);
    $headerNavbar.removeClass(`${animateNavCont}`);
}

function toggleTitle() {
    let titleToggle = 'titletoggle';
    $(`.navbar-nav__button[data-${titleToggle}]`).each(function() {
        let $this = $(this);
        let title = $this.data(titleToggle);
        if(title) {
            $this.data(titleToggle, $this.text());
            $this.text(title);
        }
    });
}

function animateHeader() {
    let topPos = $window.scrollTop();
    let windowSize = $window.width();

    if(windowSize >= 1143) {
    // Foward animations
        if(topPos >= 250) {
            if(!firstActive) {
                requestAnimationFrame(function(timestamp) { // eslint-disable-line
                    startTime = timestamp || new Date().getTime();
                    toggleTitle();
                    fowardAnimation(timestamp, 250);
                    firstActive = true;
                });
            }
            // Reverse animations
        } else if(topPos <= 100) {
            if(firstActive) {
                requestAnimationFrame(function(timestamp) { // eslint-disable-line
                    endTime = timestamp || new Date().getTime();
                    toggleTitle();
                    reverseAnimations(timestamp, 250);
                    firstActive = false;
                });
            }
        }
    }
}

function toggleMenu() {
    let $this = $(this);
    let $megaMenuMask = $('.isa-header__mega-menu-mask');
    let $megaSubMenu = $('.navbar-mega-menu__submenu');
    let $navBar = $('.isa-header__container-navbar');
    let $navigation = $('.navbar-row__navigation');
    let $navContainer = $('.navigation-container');
    let $navButton = $('.navbar-nav__button');
    let $navLabel = $('.nav-label');
    let $navFeaturedLabel = $('.navbar-mega-menu__feature-label');
    let $megaMenu = $('.navbar-mega-menu');
    let $searchMenu = $('.search-menu');
    let aria = $this.attr('aria-expanded');
    let selectedMenu = $this.data('target');
    let windowSize = $window.width();
    let subActive = false;
    $searchMenu.hide();
    $navButton.removeClass(ACTIVE);
    $this.addClass(ACTIVE);

    $megaMenu.each(function() {
        let $this = $(this);
        let menu = $this.data('menu');

        function slideMenu() {
            $this.slideToggle('fast', 'swing', function() {
                if($megaMenuMask.is(':visible') && $this.is(':hidden')) {
                    $navContainer.removeClass('menu-bar-active');
                    $navBar.removeClass('menu-bar-active');
                    $megaMenuMask.fadeOut(150);
                    subActive = true;
                }

                if($this.is(':hidden')) {
                    if(subActive) {
                        $megaSubMenu.hide();
                    }
                    subActive = false;
                }
            });
        }

        if(windowSize > 1159) {
            // Desktop menu
            $navContainer.addClass('menu-bar-active');
            $navBar.addClass('menu-bar-active');

            if(menu === selectedMenu) {
                if($this.is(':visible')) {
                    slideMenu();
                    $navButton.removeClass(ACTIVE);
                }

                if($megaMenu.is(':visible')) {
                    $megaMenu.hide();
                    $this.show();
                } else {
                    slideMenu();
                }

                if($this.hasClass('include-sub-menu') && (!subActive)) {
                    $megaSubMenu.slideDown(100);
                    subActive = true;
                } else {
                    $megaSubMenu.slideUp(100);
                }
            }

            if($megaMenuMask.is(':hidden')) {
                $megaMenuMask.fadeToggle(250);
            }
        } else {
            // Mobile menu
            if(menu === selectedMenu) {
                $navigation.hide();
                $this.show();
            }
        }
    });

    if(aria === 'true') {
        aria = 'false';
    } else {
        aria = 'true';
    }
    $this.attr('aria-expanded', aria);
    $navLabel.attr('aria-expanded', false);
    $navLabel.siblings('.collapse').removeClass('show');
    if($navLabel.hasClass('navbar-mega-menu__feature-label')) {
        $navFeaturedLabel.attr('aria-expanded', true);
        $navFeaturedLabel.siblings('.collapse').addClass('show');
    } else {
        $navLabel.attr('aria-expanded', false);
        $navLabel.siblings('.collapse').removeClass('show');
    }
}

function toggleMobileMenu() {
    let $this = $(this);
    let $navigation = $('.navbar-row__navigation');
    let $menuMask = $('.isa-header__mega-menu-mask');
    let $megaMenu = $('.navbar-mega-menu');
    let $searchMenu = $('.search-menu');
    let currentClass = $this.attr('class');
    let menuClose = '.menu-close';
    let menuOpen = '.menu-open';

    $(`${menuOpen}, ${menuClose}`).toggle();

    $('body').toggleClass('no-scroll');

    if(currentClass === 'menu-close') {
        $navigation.hide();
        $megaMenu.hide();
    } else {
        $navigation.show();
    }
    $searchMenu.hide();
    $menuMask.css('background-color', 'white');
    $menuMask.toggle();
}

function mobileMenuReturn() {
    let $navigation = $('.navbar-row__navigation');
    let $menu = $('.navbar-mega-menu');

    $menu.hide();
    $navigation.show();
}

function showUserAccountMenu() {
    let $accountMenu = $('.account-menu');
    collapseAllSubmenus('.mobile');
    $accountMenu.toggle();
    mobileNavbarIconsToggle($accountMenu);
}

function submitSearch() {
    console.log('Submit search', $(this));
    let $searchInputHeader = $('.navbar__search');
    let $submitForm = $('#searchForm');
    console.log($searchInputHeader.val());
    if($searchInputHeader.val()) {
        console.log($submitForm);
        $submitForm.submit();
    }
}

function clearTextField() {
    console.log('clear text field');
    $('.navbar__search-form-label').removeClass('is--active');
    $('.navbar__search-form-label').hide();
    $('.navbar-icons__close-btn').hide();
    $('.navbar__search').val('');
    $('.navbar__search').css('padding-top', '');
    $('.navbar__search').css('padding-bottom', '');
}

function onSearchInputClick() {
    console.log('entered into field');
    let $searchInputHeader = $(this);
    if($(window).width() <= 1159) {
        $('.navbar-icons__close-search').show();
    }
    let $searchLabel = $(this).siblings('.navbar__search-form-label');
    if($searchInputHeader.val() === '') {
        $searchLabel.removeClass('is--active');
        $searchLabel.hide();
        $searchInputHeader.css('padding-bottom', '');
        $searchInputHeader.css('padding-top', '');
        $('.navbar-icons__close-btn').hide();
    } else {
        $searchLabel.addClass('is--active');
        $searchLabel.show();
        $('.navbar-icons__close-btn').show();
        $searchInputHeader.css('padding-bottom', '1px');
        $searchInputHeader.css('padding-top', '10px');
    }
}

function mobileNavbarIconsToggle($menu) {
    let $headerContainer = $('.isa-header__container-navbar');
    let $navigation = $('.navbar-row__navigation');
    let $megaMenu = $('.navbar-mega-menu');
    let $mobileBackdrop = $('.mobile-backdrop');
    let $mainContentContainer = $('.isa-main-section');
    let windowSize = $window.width();
    let menuClose = '.menu-close';
    let menuOpen = '.menu-open';
    if($menu.is(':visible')) {
        $headerContainer.removeClass('navbar-border-bottom');
        let $megaMenuMask = $('.isa-header__mega-menu-mask');
        let $megaSubMenu = $('.navbar-mega-menu__submenu');
        let $navButton = $('.navbar-nav__button');

        $megaSubMenu.hide();
        $navButton.removeClass(ACTIVE);
        if($megaMenuMask.is(':visible')) {
            $megaMenuMask.fadeToggle(250);
        }
        if($megaMenu.is(':visible')) {
            $megaMenu.hide();
        }
        if(windowSize <= 1023) {
            if($navigation.is(':visible')) {
                $navigation.hide();
            }
            if($megaMenu.is(':visible')) {
                $megaMenu.hide();
            }
            $mobileBackdrop.show();
            $mainContentContainer.css('position', 'fixed');
            $(`${menuOpen}`).show();
            $(`${menuClose}`).hide();
        }
    } else {
        $headerContainer.addClass('navbar-border-bottom');
        $mobileBackdrop.hide();
        $mainContentContainer.css('position', 'unset');
    }
}

function doGlobalSearch(event) {
    $('.spinner-border').show();
}

function closeMenu() {
    let $this = $(this);
    let $navButton = $('.navbar-nav__button');
    let $navBar = $('.isa-header__container-navbar');
    let $navContainer = $('.navigation-container');
    let $megaMenu = $('.navbar-mega-menu');
    let $megaSubMenu = $('.navbar-mega-menu__submenu');
    $this.hide();
    $megaMenu.hide();
    $navContainer.removeClass('menu-bar-active');
    $navBar.removeClass('menu-bar-active');
    $navButton.removeClass(ACTIVE);
    $megaSubMenu.slideUp(100);
}

async function closeCABOSession() {
    loadSpinner();
    var result = await accountService.closeCABOSession();
    if(result) {
        window.location = result;
    }
    stopSpinner();
}

function closingOuterDropdown(e) {
    if($(window).width() >= 1160) {
        let parent = $(e.target).closest('.navbar-icons__account');
        if(!$(parent).length) {
            collapseAllSubmenus('.desktop');
            let ddMenu = $('#dropdownAccountLink').siblings('.dropdown-menu.navbar-icons__account-dropdown').first();
            if($(ddMenu).hasClass('show')) {
                $(ddMenu).removeClass('show');
            }
        }
    }
}

function collapseAllSubmenus(className) {
    const divSelector = `${className} .navbar-icons__account-label-bp`;
    const businessSectionDiv = $(`${divSelector}.business-section`);
    if(businessSectionDiv.length) {
        let openMenuIcon = $(businessSectionDiv).find('.bp-menu-open');
        let closeMenuIcon = $(businessSectionDiv).find('.bp-menu-close');
        $(closeMenuIcon).removeClass('d-none');
        $(openMenuIcon).removeClass('d-none');
        $(closeMenuIcon).addClass('d-none');
        const menuDetails = $(businessSectionDiv).find('.icon-link-bp-section').first();
        $(menuDetails).removeClass('hide-sub-menu-list');
        $(menuDetails).addClass('hide-sub-menu-list');
    }

    const bpSectionDiv = $(`${divSelector}.bp-section`);
    if(bpSectionDiv.length) {
        let openMenuIcon = $(bpSectionDiv).find('.bp-menu-open');
        let closeMenuIcon = $(bpSectionDiv).find('.bp-menu-close');
        $(closeMenuIcon).removeClass('d-none');
        $(openMenuIcon).removeClass('d-none');
        $(closeMenuIcon).addClass('d-none');
        const menuDetails = $(bpSectionDiv).find('.icon-link-bp-section').first();
        $(menuDetails).removeClass('hide-sub-menu-list');
        $(menuDetails).addClass('hide-sub-menu-list');
    }
}

function desktopMenu() {
    let ddMenu = $(this).siblings('.dropdown-menu.navbar-icons__account-dropdown').first();
    let isShow = $(ddMenu).hasClass('show');
    if(isShow) {
        collapseAllSubmenus('.desktop');
    }
    if(isShow) {
        $(ddMenu).removeClass('show');
    } else {
        $(ddMenu).addClass('show');
    }
}

function initEventHandlers() {
    let $headerContainer = $('.isa-header__container');
    let $searchButton = $('.navbar-icons__search-open');
    let $accountLinkButton = $('.navbar-icons__account-link-mobile');
    let $mobileNavButton = $('.mobile-nav-header');
    let $mobileButton = $('.navbar-toggler img');
    let $mobileSpan = $('.navbar-toggler span');
    let $searchClose = $('.icon-search-close');
    let $accountMenuClose = $('.icon-account-menu-close');
    let $navButton = $('.navbar-nav__button');
    let $menuOverlay = $('.isa-header__mega-menu-mask');
    let windowSize = $window.width();
    let $submitSearchForm = $('#searchForm');
    let $headerCartItems = $('.header__cart-items');
    let $closeButton = $('.navbar-icons__close-btn');
    let $navbarSearch = $('.navbar__search');
    $('.navbar-icons__close-btn').hide();
    $closeButton.on('click', clearTextField);
    $mobileNavButton.on('click', mobileMenuReturn);
    $mobileButton.on('click', toggleMobileMenu);
    $mobileSpan.on('click', toggleMobileMenu);
    $searchButton.on('click', submitSearch);
    $accountLinkButton.on('click', showUserAccountMenu);
    $searchClose.on('click', submitSearch);
    $accountMenuClose.on('click', showUserAccountMenu);
    $navButton.on('click', toggleMenu);
    $navbarSearch.on('input', onSearchInputClick);

    if(windowSize > 1160) {
        $menuOverlay.on('click', closeMenu);
    }
    $submitSearchForm.on('submit', doGlobalSearch);

    if (self !== top) { // eslint-disable-line
        $headerContainer.addClass('isa-header--unfix');
    } else {
        $headerContainer.addClass('isa-header--fix');
    }
    if(!$headerCartItems.is(':empty')) {
        $headerCartItems.removeClass('d-none');
    }

    $('#dropdownAccountLink').on('click', desktopMenu);

    $('.navbar-icons__account-label-bp-header').on('click', subBpMenuOpenClose);

    $('body').on('click', '.icon-link-button', handleClickMenuSubItems);
    $window.on('scroll', animateHeader);
    headerHeightCalculation();
    toggleSubmenuHeaderMobile();
    var $btnCloseCABOSession = $('#btnCloseCABOSession');
    if($btnCloseCABOSession.length > 0) {
        $btnCloseCABOSession.on('click', closeCABOSession);
    }
    if($('.signin-tooltip').length > 0) {
        var dialogShown = $.cookie('tooltipShown');
        var toolTipDuration = $('#tooltipduration').val();
        if(!dialogShown) {
            $('.signin-tooltip').show();
            setTimeout(() => {
                $('.signin-tooltip').hide();
            }, toolTipDuration);
            $('.signin-tooltip svg').click(function() {
                $('.signin-tooltip').hide();
                $.cookie('tooltipShown', 1, { path: '/' });
            });
            $.cookie('tooltipShown', 1, { path: '/' });
        }
    }

    $('body').click(closingOuterDropdown);
    initializeKeyboardNavigation();
}

function handleArrowLeftRight(e) {
    if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        if($(e.currentTarget).attr('aria-expanded') === 'true') {
            $(e.currentTarget).trigger('click');
        }
        const parentLi = $(e.currentTarget).closest('.navbar-nav__item');
        // find its index
        const parentNav = $(e.currentTarget).closest('.navbar-nav');
        const listItems = parentNav.find('.navbar-nav__item');
        const index = listItems.index(parentLi);
        let targetIndex = -1;
        if(e.key === 'ArrowRight') {
            e.preventDefault();
            targetIndex = (index + 1) % listItems.length;
        } else if(e.key === 'ArrowLeft') {
            e.preventDefault();
            targetIndex = (index - 1 + listItems.length) % listItems.length;
        }

        if(targetIndex >= 0) {
            const $targetCol = listItems.eq(targetIndex);
            const $focusable = $targetCol.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
            if($focusable.length) {
                $focusable.focus();
            }
        }
    }
}

function initializeKeyboardNavigation() {
    $('.isa-header__container').on('keydown', '.navbar-nav__button[aria-haspopup="true"]', function (e) {
        if(e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if($(this).attr('aria-expanded') !== 'true') {
                $(this).trigger('click');
            }
            const correspondingTabClass = $(this).attr('aria-controls');
            const parent = $(this).closest('.navbar.navigation-container');
            const correspondingTab = parent.find(`.navbar-mega-menu.${correspondingTabClass}`);
            const $focusable = correspondingTab.find('.navbar-mega-sub-header a.link-primary').filter(':visible').first();
            if($focusable.length) {
                $focusable.focus();
            } else {
                const firstColumn = correspondingTab.find('.col-3').find('a, button').filter(':visible').first();
                if(firstColumn.length) {
                    firstColumn.focus();
                }
            }
        }
        if(e.key === 'Escape' && $(this).attr('aria-expanded') === 'true') {
            e.preventDefault();
            $(this).trigger('click');
        }

        handleArrowLeftRight(e);
    });

    $('.isa-header__container').on('keydown', '.navbar-nav__item.navbar-nav__item-quiz a.nav-link', function (e) {
        handleArrowLeftRight(e);
    });

    $('.isa-header__container').on('keydown', '.navbar-mega-sub-header a.link-primary', function (e) {
        if(e.key === 'ArrowDown') {
            e.preventDefault();
            const parent = $(this).closest('.row');
            const firstColumn = parent.find(`.col-3`).filter(':visible').first();
            const $focusable = firstColumn.find('a, button').filter(':visible').first();
            if($focusable.length) {
                $focusable.focus();
            }
        }
    });
    $('.isa-header__container').on('keydown', '.navbar-mega-sub-header a.link-primary', function (e) {
        if(e.key === 'ArrowUp' || (e.key === 'Tab' && e.shiftKey)) {
            e.preventDefault();
            const parent = $(this).closest('.navbar-mega-menu');
            if(parent.length) {
                const classAttr = parent.attr('class') || '';
                const classes = classAttr.split(' ');
                const menuTabClass = classes.find(c => c.startsWith('menu-tab-'));
                if(!menuTabClass) return;
                const $target = $('.navbar-nav__button.active[aria-controls="' + menuTabClass + '"]');
                if($target.length && $target.is(':visible')) {
                    $target.trigger('click');
                    $target.focus();
                }
            }
        }
    });

    $('.isa-header__container').on('keydown', function (e) {
        if(e.key === 'Escape') {
            let $focused = $(document.activeElement);
            let parentTabItem = $focused.closest('.isa-header__container .navbar-mega-menu');
            if($(parentTabItem).length) {
                const classAttr = $(parentTabItem).attr('class') || '';
                const classes = classAttr.split(' ');
                const menuTabClass = classes.find(c => c.startsWith('menu-tab-'));
                if(!menuTabClass) return;
                const $target = $('.navbar-nav__button.active[aria-controls="' + menuTabClass + '"]');
                if($target.length && $target.is(':visible')) {
                    $target.trigger('click');
                    $target.focus();
                }
            }
        }
    });

    $('.isa-header__container').on('keydown', '.navbar-mega-menu button.nav-label, .navbar-mega-menu div.navbar-mega-menu__feature a', function (e) {
        const $currentCol = $(this).closest('.col-3');
        const $cols = $currentCol.closest('.navbar-mega-menu').find('.col-3');
        const index = $cols.index($currentCol);
        let targetIndex = -1;
        if(e.key === 'ArrowRight') {
            e.preventDefault();
            targetIndex = (index + 1) % $cols.length;
        } else if(e.key === 'ArrowLeft') {
            e.preventDefault();
            targetIndex = (index - 1 + $cols.length) % $cols.length;
        }

        if(targetIndex >= 0) {
            const $targetCol = $cols.eq(targetIndex);
            const $focusable = $targetCol.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
            if($focusable.length) {
                $focusable.focus();
            }
        }
    });

    $('.isa-header__container').on('keydown', '.navbar-mega-menu button.nav-label', function (e) {
        if(e.key === 'ArrowDown') {
            e.preventDefault();
            const $currentCol = $(this).siblings('.menu-group').children('a').filter(':visible').first();
            $currentCol.focus();
        }
    });
    $('.isa-header__container').on('keydown', '.navbar-mega-menu .menu-group a', function (e) {
        const $links = $(this).closest('.menu-group').children('a');
        const index = $links.index($(this));
        let targetIndex = -1;
        if(e.key === 'ArrowDown') {
            e.preventDefault();
            targetIndex = (index + 1) % $links.length;
        } else if(e.key === 'ArrowUp') {
            e.preventDefault();
            targetIndex = (index - 1 + $links.length) % $links.length;
        }

        if(targetIndex >= 0) {
            const $targetCol = $links.eq(targetIndex);
            if($targetCol.length) {
                $targetCol.focus();
            }
        }
    });
}

function subBpMenuOpenClose(e) {
    e.stopPropagation();
    const isMobile = $(this).closest('.navbar-icons__loggedin-links.mobile');
    const selector = isMobile.length ? `.mobile .navbar-icons__account-label-bp` : `.desktop .navbar-icons__account-label-bp`;
    const parent = $(this).closest(selector);
    if($(parent).hasClass('bp-section')) {
        // click happened in bp
        // close all business section
        const divSelector = isMobile.length ? `.mobile .navbar-icons__account-label-bp.business-section` : `.desktop .navbar-icons__account-label-bp.business-section`;
        const businessSectionDiv = $(divSelector);
        if(businessSectionDiv.length) {
            let openMenuIcon = $(businessSectionDiv).find('.bp-menu-open');
            let closeMenuIcon = $(businessSectionDiv).find('.bp-menu-close');
            $(closeMenuIcon).removeClass('d-none');
            $(openMenuIcon).removeClass('d-none');
            $(closeMenuIcon).addClass('d-none');
            const menuDetails = $(businessSectionDiv).find('.icon-link-bp-section').first();
            $(menuDetails).removeClass('hide-sub-menu-list');
            $(menuDetails).addClass('hide-sub-menu-list');
        }

        const openMenuIcon = $(this).find('.bp-menu-open');
        const closeMenuIcon = $(this).find('.bp-menu-close');
        $(openMenuIcon).toggleClass('d-none');
        $(closeMenuIcon).toggleClass('d-none');
        const menuDetails = $(this).siblings('.icon-link-bp-section').first();
        $(menuDetails).toggleClass('hide-sub-menu-list');
    }
    if($(parent).hasClass('business-section')) {
        // click happened in business section
        // close all bp section
        const divSelector = isMobile.length ? `.mobile .navbar-icons__account-label-bp.bp-section` : `.desktop .navbar-icons__account-label-bp.bp-section`;
        const bpSectionDiv = $(divSelector);
        if(bpSectionDiv.length) {
            let openMenuIcon = $(bpSectionDiv).find('.bp-menu-open');
            let closeMenuIcon = $(bpSectionDiv).find('.bp-menu-close');
            $(closeMenuIcon).removeClass('d-none');
            $(openMenuIcon).removeClass('d-none');
            $(closeMenuIcon).addClass('d-none');
            const menuDetails = $(bpSectionDiv).find('.icon-link-bp-section').first();
            $(menuDetails).removeClass('hide-sub-menu-list');
            $(menuDetails).addClass('hide-sub-menu-list');
        }

        const openMenuIcon = $(this).find('.bp-menu-open');
        const closeMenuIcon = $(this).find('.bp-menu-close');
        $(openMenuIcon).toggleClass('d-none');
        $(closeMenuIcon).toggleClass('d-none');
        const menuDetails = $(this).siblings('.icon-link-bp-section').first();
        $(menuDetails).toggleClass('hide-sub-menu-list');
    }
}

async function handleClickMenuSubItems(e) {
    const isSameFlow = $(this).data('is-same-flow') === 'True';
    const shopPageUrl = $(this).data('shop-page-url');

    if(isSameFlow && shopPageUrl !== undefined && shopPageUrl !== '') {
        window.location.href = shopPageUrl;
        return;
    }

    const market = $(this).data('market');
    const action = $(this).data('flow');
    const orderSubType = $(this).data('order-sub-type');
    const selectedContextValue = window.algoliaData.hiddenCultureCode;
    if(action === undefined || action === null) {
        return;
    }

    let request = {
        Action: action,
        Market: market,
        OrderSubType: orderSubType,
        SelectedContextValue: selectedContextValue
    };
    try {
        loadSpinner();
        const result = await recommendedCartService.setShoppingContextUrl(request);
        stopSpinner();
        if(result) {
            window.location.href = result;
        }
    } catch (ex) {
        stopSpinner();
        console.log('error while setting up the shopping context:', ex);
    }
}

function toggleSubmenuHeaderMobile() {
    if($(window).width() <= 1160) {
        $('.navbar-mega-menu__sub-menu-header').attr({
            'data-toggle': 'collapse'
        });
    } else {
        $('.navbar-mega-menu__sub-menu-header').removeAttr('data-toggle');
    }
}

function headerHeightCalculation() {
    // toggleSearchText();
    let $isaHeader = $('.isa-header');
    let $isaMain = $('.isa-main-section');
    let $headerDefaultHeight = $isaHeader.css('height', '').height();

    if($isaHeader.hasClass('isa-header--checkout')) {
        $isaHeader.parents('header').addClass('header-checkout');
        $isaMain.css({
            'margin-top': 0
        });
    } else {
        $isaHeader.parents('header').addClass('header-default');
        console.log('Recalculated header: ', $headerDefaultHeight);
    /* Not required, when header display prop is not fixed
        $isaMain.css({
            'margin-top': $headerDefaultHeight + 'px'
        }); */
    }
}

function ensurePageVisibilityOnError() {
    // make sure 404 error pages are visible
    let $body = $('body');
    if($('.error-container__body').length > 0) {
        $body.css('visibility', 'visible');
    } else {
        if($body.css('visibility').toLowerCase() === 'hidden') {
            // used for tracking page's visible state
            console.log("Page's body is NOT visible.");
        }
    }
}

$(function () {
    ensurePageVisibilityOnError();
    initEventHandlers();
});

$(window).on('load', function () {
    headerHeightCalculation();
});
$(window).on('resize', function () {
    setTimeout(function () {
        headerHeightCalculation();
    }, 300);
    toggleSubmenuHeaderMobile();
});

jQuery('.form-label-plp').on('click', () => { jQuery('.form-input.form-input--search').focus(); });
